(() => {
  if (window.AndreaGlobalMotionLoaded) return;
  window.AndreaGlobalMotionLoaded = true;
})();

/* ANDREA / CASA FACILE — Premium glow system v18 pre-launch */
(() => {
  'use strict';

  if (window.__andreaPremiumGlowV14) return;
  window.__andreaPremiumGlowV14 = true;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = window.matchMedia('(max-width: 749px)');
  const buttonSelector = '.button, button, [role="button"], .cf-button, .cfm-btn, .cfm-official-card__cta, .cf-square-window__btn, .ae-home__btn, .product-form__submit, .quick-add__submit';
  const cardSelector = '.ae-home-card, .ae-home-quickbar a, .cf-square-window__visual, .cfm-card, .cfm-package, .cf-card, .cf37-card';
  const mobileScrollSelector = '.ae-home-card, .ae-home-quickbar a, .cf-square-window__visual, .cf-card, .cf37-card';
  const pulseTimers = new WeakMap();
  const buttonTimers = new WeakMap();
  let observer = null;

  const injectStyles = () => {
    if (document.getElementById('ae-premium-glow-v14')) return;
    const style = document.createElement('style');
    style.id = 'ae-premium-glow-v14';
    style.textContent = `
      html:not(.ae-motion-reduced) main .ae-premium-button{
        transition:transform .2s cubic-bezier(.22,1,.36,1),box-shadow .28s ease,filter .28s ease!important;
      }
      @media(hover:hover){
        html:not(.ae-motion-reduced) main .ae-premium-button:hover,
        html:not(.ae-motion-reduced) main .ae-premium-button:focus-visible{
          filter:brightness(1.045) saturate(1.06);
          box-shadow:0 12px 32px rgba(16,47,58,.20),0 0 0 1px rgba(103,199,234,.24),0 0 30px rgba(103,199,234,.24)!important;
        }
      }
      html:not(.ae-motion-reduced) main .ae-premium-button.is-ae-button-glow{
        filter:brightness(1.05) saturate(1.06);
        box-shadow:0 10px 28px rgba(16,47,58,.18),0 0 0 1px rgba(103,199,234,.24),0 0 26px rgba(103,199,234,.25)!important;
      }
      html:not(.ae-motion-reduced) main .ae-premium-card{
        position:relative;
        isolation:isolate;
        transition:none!important;
      }
      html:not(.ae-motion-reduced) main .ae-premium-card::after{
        content:"";
        position:absolute;
        inset:0;
        z-index:4;
        pointer-events:none;
        border-radius:inherit;
        background:linear-gradient(108deg,transparent 18%,rgba(255,255,255,.06) 34%,rgba(103,199,234,.28) 47%,rgba(255,255,255,.24) 53%,transparent 70%);
        background-size:100% 100%;
        opacity:0;
        transform:scaleX(.35);
        transform-origin:center;
        will-change:transform,opacity;
        transition:transform .78s cubic-bezier(.2,.8,.2,1),opacity .2s ease;
      }
      @media(hover:hover){
        html:not(.ae-motion-reduced) main .ae-premium-card:hover,
        html:not(.ae-motion-reduced) main .ae-premium-card:focus-visible{
          filter:saturate(1.035) brightness(1.008);
          box-shadow:0 20px 54px rgba(16,47,58,.18),0 0 0 1px rgba(103,199,234,.24),0 0 32px rgba(103,199,234,.18);
        }
        html:not(.ae-motion-reduced) main .ae-premium-card:hover::after,
        html:not(.ae-motion-reduced) main .ae-premium-card:focus-visible::after{
          opacity:.92;
          transform:scaleX(1);
        }
      }
      html:not(.ae-motion-reduced) main .ae-premium-card.is-ae-glow-active{
        filter:saturate(1.025) brightness(1.006);
        box-shadow:0 16px 44px rgba(16,47,58,.16),0 0 0 1px rgba(103,199,234,.22),0 0 28px rgba(103,199,234,.17);
      }
      html:not(.ae-motion-reduced) main .ae-premium-card.is-ae-glow-active::after,
      html:not(.ae-motion-reduced) main .cfm-card.is-cf-carousel-focus.ae-premium-card::after,
      html:not(.ae-motion-reduced) main .cfm-package.is-cf-carousel-focus.ae-premium-card::after{
        animation:aePremiumSweepV14 .92s cubic-bezier(.2,.8,.2,1);
      }
      @keyframes aePremiumSweepV14{
        0%{opacity:0;transform:scaleX(.25)}
        25%{opacity:.86}
        75%{opacity:.72}
        100%{opacity:0;transform:scaleX(1.05)}
      }
      @media(prefers-reduced-motion:reduce){
        .ae-premium-button,.ae-premium-card,.ae-premium-card::after{
          transition:none!important;
          animation:none!important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const addPremiumClasses = (scope = document) => {
    scope.querySelectorAll(buttonSelector).forEach((button) => {
      if (!button.closest('main')) return;
      button.classList.add('ae-premium-button');
    });
    scope.querySelectorAll(cardSelector).forEach((card) => {
      if (!card.closest('main')) return;
      card.classList.add('ae-premium-card');
    });
  };

  const pulseCard = (card) => {
    if (!card || reduced.matches) return;
    const now = Date.now();
    const previous = Number(card.dataset.aeGlowAt || 0);
    if (now - previous < 1500) return;
    card.dataset.aeGlowAt = String(now);
    if (card.classList.contains('is-ae-glow-active')) return;
    card.classList.add('is-ae-glow-active');
    const previousTimer = pulseTimers.get(card);
    if (previousTimer) window.clearTimeout(previousTimer);
    const timer = window.setTimeout(() => card.classList.remove('is-ae-glow-active'), 1050);
    pulseTimers.set(card, timer);
  };

  const setupMobileObserver = () => {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    if (!mobile.matches || reduced.matches || !('IntersectionObserver' in window)) return;
    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) pulseCard(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '-25% 0px -25% 0px' });
    document.querySelectorAll(mobileScrollSelector).forEach((card) => {
      if (!card.closest('main')) return;
      observer.observe(card);
    });
  };

  const init = (scope = document) => {
    injectStyles();
    addPremiumClasses(scope);
    setupMobileObserver();
  };

  document.addEventListener('pointerdown', (event) => {
    const button = event.target.closest('.ae-premium-button');
    if (!button || reduced.matches) return;
    button.classList.add('is-ae-button-glow');
    const previousTimer = buttonTimers.get(button);
    if (previousTimer) window.clearTimeout(previousTimer);
    const timer = window.setTimeout(() => button.classList.remove('is-ae-button-glow'), 420);
    buttonTimers.set(button, timer);
  }, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  mobile.addEventListener?.('change', setupMobileObserver);
  reduced.addEventListener?.('change', setupMobileObserver);
})();

/* CASA FACILE — definitive mobile carousel sizing + cadence v18.5 */
(() => {
  'use strict';

  const isCasaFacileHome = () =>
    document.body &&
    document.body.classList.contains('template-casa-facile-shop') &&
    document.body.classList.contains('cf-page-type-page');

  if (!isCasaFacileHome()) return;

  /* The active home runtime creates these exact carousel intervals after this deferred file.
     Tune only those two known delays, then restore the native API after page load. */
  const nativeSetInterval = window.setInterval;
  let intervalPatchActive = true;
  window.setInterval = function(handler, delay, ...args) {
    let tunedDelay = delay;
    if (delay === 2600) tunedDelay = 2300;
    else if (delay === 3800) tunedDelay = 3300;
    return nativeSetInterval.call(window, handler, tunedDelay, ...args);
  };
  const restoreInterval = () => {
    if (!intervalPatchActive) return;
    intervalPatchActive = false;
    window.setInterval = nativeSetInterval;
  };

  const installCarouselFix = () => {
    if (!isCasaFacileHome()) return;
    document.getElementById('cf-mobile-carousel-definitive-v18-5')?.remove();
    document.getElementById('cf-home-mobile-card-tuning-v18-4')?.remove();

    const style = document.createElement('style');
    style.id = 'cf-mobile-carousel-definitive-v18-5';
    style.textContent = `
      @media (max-width:649px) {
        html body.template-casa-facile-shop.cf-page-type-page #MainContent #soluzioni .cfm-card-grid,
        html body.template-casa-facile-shop.cf-page-type-page #MainContent #pacchetti .cfm-package-grid {
          display:flex!important;
          flex-flow:row nowrap!important;
          grid-template-columns:none!important;
          grid-auto-flow:initial!important;
          grid-auto-columns:initial!important;
          align-items:stretch!important;
          width:100%!important;
          max-width:100%!important;
          gap:10px!important;
          overflow-x:auto!important;
          overflow-y:hidden!important;
          overscroll-behavior-inline:contain!important;
          scroll-snap-type:x mandatory!important;
          scroll-padding-inline:1px!important;
          padding:4px 24vw 11px 1px!important;
          -webkit-overflow-scrolling:touch!important;
          scrollbar-width:none!important;
        }

        html body.template-casa-facile-shop.cf-page-type-page #MainContent #soluzioni .cfm-card-grid::-webkit-scrollbar,
        html body.template-casa-facile-shop.cf-page-type-page #MainContent #pacchetti .cfm-package-grid::-webkit-scrollbar {
          display:none!important;
          width:0!important;
          height:0!important;
        }

        html body.template-casa-facile-shop.cf-page-type-page #MainContent #soluzioni .cfm-card-grid > .cfm-card,
        html body.template-casa-facile-shop.cf-page-type-page #MainContent #soluzioni .cfm-card-grid > .cfm-official-card:nth-child(4),
        html body.template-casa-facile-shop.cf-page-type-page #MainContent #pacchetti .cfm-package-grid > .cfm-package {
          flex:0 0 min(238px,76vw)!important;
          width:min(238px,76vw)!important;
          min-width:min(238px,76vw)!important;
          max-width:min(238px,76vw)!important;
          grid-column:auto!important;
          display:flex!important;
          flex-direction:column!important;
          scroll-snap-align:start!important;
          scroll-snap-stop:always!important;
          writing-mode:horizontal-tb!important;
          word-break:normal!important;
          overflow-wrap:normal!important;
        }

        html body.template-casa-facile-shop.cf-page-type-page #MainContent :is(#soluzioni,#pacchetti) .cfm-official-card__header h3,
        html body.template-casa-facile-shop.cf-page-type-page #MainContent :is(#soluzioni,#pacchetti) .cfm-official-card__header h3 a {
          width:100%!important;
          min-width:0!important;
          font-size:15px!important;
          line-height:1.18!important;
          white-space:normal!important;
          writing-mode:horizontal-tb!important;
          word-break:normal!important;
          overflow-wrap:break-word!important;
          hyphens:none!important;
          text-align:center!important;
        }

        html body.template-casa-facile-shop.cf-page-type-page #MainContent :is(#soluzioni,#pacchetti) .cfm-official-card__media {
          width:calc(100% - 18px)!important;
          margin-inline:9px!important;
          aspect-ratio:16/9!important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  installCarouselFix();

  if (document.readyState === 'complete') restoreInterval();
  else window.addEventListener('load', restoreInterval, { once:true });

  document.addEventListener('shopify:section:load', () => {
    window.requestAnimationFrame(installCarouselFix);
  });
})();
